import React, { useEffect, useState } from "react";
import "./RentalsPage.css";

export default function RentalsPage() {
  const [listings, setListings] = useState([]);
  const [error, setError] = useState("");

  const API = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(`${API}/api/rentals`);
        if (!res.ok) {
          setError("Failed to load rental listings");
          return;
        }
        setListings(await res.json());
      } catch (err) {
        setError("Server error while loading rentals");
      }
    };
    load();
  }, [API]);

  return (
    <div className="rentals-page">
      <h2>Rentals</h2>
      <p className="rentals-page-intro">
        Rental listings posted directly by residents of Crown Residences.
      </p>

      {error && <p className="rentals-page-error">{error}</p>}

      <div className="rentals-page-grid">
        {listings.map((l) => (
          <div className="rentals-card" key={l.id}>
            <div className="rentals-card-title">{l.title}</div>
            <div className="rentals-card-location">{l.tower} · {l.unitNumber}</div>
            <div className="rentals-card-meta">
              ₹{l.rentAmount}/month · {l.bedrooms} · Available {l.availableFrom}
            </div>
            <div className="rentals-card-desc">{l.description}</div>
            <div className="rentals-card-contact">
              Contact: {l.residentName} · {l.contactPhone}
            </div>
          </div>
        ))}
      </div>

      {listings.length === 0 && !error && (
        <p className="rentals-page-empty">No rental listings available right now.</p>
      )}
    </div>
  );
}